import { gql } from "@/services/httpAdapter.ts";

export const FinanceDetailFragment = gql`
	fragment FinanceDetail on FinanceDetail {
		_id
		locationId
		commissionCycleId
		payPeriodId
		creationDateTime
		dealNumber
		vinNumber
		stockNumber
		status
		financeManagerName
		finance {
			rate
			rateType
			charge
			effectiveAOR
			apr
			deferredPaymentPrice
			equivalentSimpleRate
			equivalentAOR
			netCapCost
			term
			amountFinanced
			fixedVariable
			moneyFactor
			charges {
				dealDecreasingLifePremium
				dealLevelLifePremium
				ahPremium
				totalAccessoriesAmount
				proRataAmount
				gapPremium
				vsiPremium
				pdiPremium
				totalAftermarketPriceFinance
				totalAftermarketPrice
				otherPremium
				iuiPremium
				mbiPremium
			}
			fees {
				oneYear
				total
				official {
					license
					items {
						amount
						description
					}
				}
				unOfficial {
					cvr
					purchaseOption
					disposition
					reconditioningCost
					docFeeHandling
					docFee
					items {
						amount
						description
					}
				}
				capitalReduction {
					totalPositiveTradeEquity
					totalCashDown
					deposit
					cash
					total
					totalDown
				}
			}
			payments {
				totalDriveOff
				base
				firstDate
				total
				monthly
				amountOfYearly
				irregularAmount
				daysFirst
				final
				onePayDueDate
				lastInstallmentDate
				noOfAdvance
				totalDeferred
				totalIncludingPicks
				totalInitial
				onePayAmount
			}
			taxes {
				total
				proRata
				threshold
				luxuryAmount
				luxuryAmountBasis
			}
			institution {
				lenderId
				lenderName
				lenderType
			}
			prePaidFinance
			lease {
				advanceMonthlyPayment
				depreciatedValue
				distanceDrivenTerm
				securityDeposit
				chargePerMileForExcess
				adjustmentToResidual
				adjustedResidual
				monthlyDeprecation
				vehicleResidual
				distanceDrivenYearly
				estimateMilesPerTerm
				estimateMilesMonthly
				estimateMilesYearly
				totalTermDepreciation
				monthlyLeaseCharge
				miscellaneousUpfrontTotal
				estimateExcessMileageCharge
				residualBasis
				adjustedPercentageForResidual
				amountAcquisitionFee
			}
			incentive {
				description
				isExcludedFromGross
				amount
			}
			rebate {
				description
				amount
			}
		}
		recap {
			buyRate
			pack
			otherEquity
			holdBack
			costing {
				serviceContract
				acquisitionFee
				reconditioning
				totalOfDriveOff
				pdi
				mbi
				totalAftermarket
			}
			commission {
				totalBackEnd
				totalFrontEnd
				totalSalesman
				totalFI
				grossPayable
			}
			reserve {
				gap
				mbi
				totalLAH
				profitDriveOff
				optPkgDiscount
				totalFI
				physicalDamage
				baseFinance
				life
				netFI
				totalInsurance
				netProfitOnVehicle
				vehicleGross
				serviceContract
				totalAftermarket
				grossProfitOnVehicle
				finance
				acquisitionFee
				grossAdjustment {
					amount
					excludedFromGross
				}
			}
		}
		inventory {
			memoLine1
			memoLine2
			costPackAmount
		}
		aftermarket {
			isTaxIncluded
			cost
			commission
			price
			description
			profitType
			code
		}
		weOwe {
			amount
			description
			sendToService
		}
		saleDate
		createdAt
		updatedAt
	}
`;
